function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames';
import { SVGIcon } from '@homeaway/react-svg';
import { CHEVRON_DOWN__16 } from '@homeaway/svg-defs';
import CollapseBase from '../CollapseBase/CollapseBase';
import "./Divider.css";

var Divider = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Divider, _Component);

  function Divider(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _this.handleClick = function (e) {
      e.preventDefault();
      var isExpanded = !_this.state.isExpanded;

      _this.setState({
        isExpanded: isExpanded
      });

      _this.props.onExpandedChange(isExpanded);
    };

    _this.state = {
      isExpanded: _this.props.expanded
    };
    return _this;
  }

  var _proto = Divider.prototype;

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.props.expanded !== prevProps.expanded) {
      this.setState({
        // eslint-disable-line
        isExpanded: this.props.expanded
      });
    }
  };

  _proto.render = function render() {
    /* eslint-disable no-unused-vars */
    // Extracting expanded and onExpandedChange so they aren't included in ...rest
    var _this$props = this.props,
        ariaLevel = _this$props.ariaLevel,
        children = _this$props.children,
        className = _this$props.className,
        expanded = _this$props.expanded,
        heading = _this$props.heading,
        id = _this$props.id,
        onExpandedChange = _this$props.onExpandedChange,
        rest = _objectWithoutProperties(_this$props, ["ariaLevel", "children", "className", "expanded", "heading", "id", "onExpandedChange"]);
    /* eslint-enable no-unused-vars */


    var isExpanded = this.state.isExpanded;
    var divClassName = classNames('Divider', className);
    var svgClassName = classNames('Divider__SVGIcon', {
      'Divider__SVGIcon--collapsed': !isExpanded
    });
    var dividerId = id + "_button";
    return /*#__PURE__*/React.createElement("div", _extends({
      className: divClassName
    }, rest), /*#__PURE__*/React.createElement("div", _extends({
      className: "Divider__heading text-muted"
    }, rest), /*#__PURE__*/React.createElement("button", {
      className: "Divider__title",
      onClick: this.handleClick,
      "aria-expanded": isExpanded,
      "aria-controls": id,
      id: dividerId
    }, /*#__PURE__*/React.createElement("div", {
      className: "Divider__title-layout"
    }, /*#__PURE__*/React.createElement("div", {
      className: "Divider__title-left"
    }, /*#__PURE__*/React.createElement("div", {
      className: "Divider__title-row"
    })), /*#__PURE__*/React.createElement("div", {
      className: "Divider__title-text"
    }, typeof heading === 'string' && /*#__PURE__*/React.createElement("span", {
      role: "heading",
      "aria-level": ariaLevel
    }, heading), typeof heading === 'function' && heading()), /*#__PURE__*/React.createElement("div", {
      className: "Divider__title-right"
    }, /*#__PURE__*/React.createElement("div", {
      className: "Divider__title-row"
    }), /*#__PURE__*/React.createElement(SVGIcon, {
      className: svgClassName,
      markup: CHEVRON_DOWN__16
    }))))), /*#__PURE__*/React.createElement(CollapseBase, {
      "aria-labelledby": dividerId,
      className: "Divider__body",
      id: id,
      expanded: isExpanded,
      role: "region"
    }, children));
  };

  return Divider;
}(Component);

Divider.propTypes = {
  /** id tag for Component. Required for assistive devices (a11y) */
  id: PropTypes.string.isRequired,

  /** Heading for the Divider Panel. A simple string or function that returns the content to render. */
  heading: PropTypes.oneOfType([PropTypes.string, PropTypes.func]).isRequired,

  /** Optional event handler to trigger when the component expands or collapses.  Passes the isExpanded boolean as a parameter. */
  onExpandedChange: PropTypes.func,

  /** Should the Divider be opened by default.  For use if being used as a controlled component. */
  expanded: PropTypes.bool,

  /** The aria-level attribute for use with heading, if heading is of type string.  Defaults to 4 to represent h4.  Please adjust within your app for proper hierarchical level. */
  ariaLevel: PropTypes.number
};
Divider.defaultProps = {
  expanded: false,
  onExpandedChange: function onExpandedChange() {},
  ariaLevel: 4
};
export default Divider;
//# sourceMappingURL=Divider.js.map